<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-select
          v-model="fileType"
          clearable
          @clear="onSearch"
          placeholder="请选择文件类型"
          style="width: 250px; margin-right: 10px"
          size="mini"
        >
          <el-option
            v-for="item in fileTypes"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="projectName"
          size="mini"
          @keydown.enter.native="onSearch"
          @clear="onSearch"
          placeholder="请输入项目名称进行搜索..."
          clearable
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          size="small"
          >搜索</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 30px">
      <el-table
        :data="incomeData"
        stripe
        :row-style="{ height: '58px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column prop="id" label="编号" align="center" width="50">
        </el-table-column>

        <!-- <el-table-column prop="fileName" label="文件名"   align="center" width="320">
				</el-table-column> -->
        <el-table-column label="文件名" align="center" >
          <template slot-scope="scope">
            <!--  方式一：pdf,png,jpg,txt文件能在线打开 word文件不能在线打开，word文件点击后会下载
						      http://139.196.252.126:8088/home/file_upload/138//20220119101153_%E6%97%A0%E7%BA%BFAP%E5%92%8C%E4%BA%A4%E6%8D%A2%E6%9C%BA%E4%B8%AD%E6%A0%87%E9%80%9A%E7%9F%A5%E4%B9%A6.pdf
						 -->
            <!-- <el-link :href="scope.row.fileRoute" target="_blank" style="font-size: 10px" size="mini" type="primary"
              :underline="false">{{ scope.row.fileName }}</el-link> -->
            <el-link
              href=""
              style="font-size: 14px"
              size="mini"
              type="primary"
              @click="handleClick(scope.row)"
              :underline="false"
              >{{ scope.row.fileName }}</el-link
            >
            <!-- 方式二： 采用 https://api.idocv.com/view/url?url= + url 方式 word,pdf,jpg,txt都能在线打开   只要打开小于1M，有水印，有时间限制
						     https://api.idocv.com/view/url?url=http://139.196.252.126:8088/home/file_upload/59//20220120185237_oracle安装.docx
						     https://api.idocv.com/view/url?url=http://139.196.252.126:8088/home/file_upload/138//20220119101153_无线AP和交换机中标通知书.pdf
							 https://api.idocv.com/view/url?url=http://139.196.252.126:8088/home/file_upload/59//20220120193650_江西省气象局_气象大脑数字大屏交流会议_会议内容纪要.txt
							 https://api.idocv.com/view/url?url=http://139.196.252.126:8088/home/file_upload/59//20220120193620_1.jpg
						  -->
            <!-- <el-button type="text" @click="wordDetail(scope.row.fileRoute)">{{scope.row.fileName}}
						</el-button> -->

            <!-- 方式三：永中云服务   有5M的限制  jpg,txt 无法打开
				                 https://open.yozocloud.cn/document/preview/5965
						-->
            <!-- <el-button type="text" @click="wordDetail2(scope.row.fileRoute)">{{scope.row.fileName}}
						</el-button> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="fileTypeName"
          label="文件类型"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="所属项目"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="上传者"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="上传时间"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="140">
          <template slot-scope="scope">
            <el-link
              :href="scope.row.fileRoute"
              target="_blank"
              style="font-size: 13px"
              size="mini"
              download
              type="primary"
              :underline="false"
              >下载</el-link
            >
            <!-- <el-link href="http://139.196.252.126/home/file_upload/1.png" target="_blank" size="mini"  type="primary" :underline="false">下载</el-link> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          small
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewPdf from "@/utils/previewPdf";
export default {
  name: "FileList",
  data() {
    return {
      headers: {
        userIdStr: window.sessionStorage.getItem("userIdStr"),
      },
      incomeData: [], // 存放查询结果
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      projectName: "",
      fileType: "",
      fileTypes: [],
      projects: [], //项目id-项目名称下拉框
    };
  },
  mounted() {
    this.initData();
    this.initDim();
  },
  methods: {
    handleClick(e) {
      // new PreviewPdf({
      //   blob: file.raw,
      //   docTitle: 'window.open docTitle',
      //   isAddWatermark: true, // 是否需要添加水印
      //   watermark: { // watermark必填 里面可以不填
      //     type: 'text',
      //     text: 'WFT'
      //   }
      // })
    },
    wordDetail(dz) {
      const url = "http://139.196.252.126:8088" + dz;
      window.open("https://api.idocv.com/view/url?url=" + url);
    },
    wordDetail2(dz) {
      let url1 = "http://139.196.252.126:8088" + dz;
      let url = new this.Base64().encode(url1);
      window.open(
        "https://open.yozocloud.cn/view/docPreview.html?url=" +
          url +
          "&host=" +
          window.location.host
      );
      // getFileUrl(url) // 调用getFileUrl方法，预览文件
    },
    Base64() {
      // private property
      let _keyStr =
        "aAbBcCdDeEfFgGhHiIjJkKlLmMnNoOpPqQrRsStTuUvVwWxXyYzZ0123456789+/=";

      // public method for encoding
      this.encode = function (data) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        var input = _utf8_encode(data);
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output =
            output +
            _keyStr.charAt(enc1) +
            _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) +
            _keyStr.charAt(enc4);
        }
        return output;
      };

      // public method for decoding
      this.decode = function (data) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        var input = data.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        output = _utf8_decode(output);
        return output;
      };

      // private method for UTF-8 encoding
      let _utf8_encode = function (str) {
        var string = str.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }
        }
        return utftext;
      };

      // private method for UTF-8 decoding
      let _utf8_decode = function (utftext) {
        var string = "";
        var i = 0;
        var c = 0,
          c2 = 0,
          c3 = 0;
        while (i < utftext.length) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
            string += String.fromCharCode(c);
            i++;
          } else if (c > 191 && c < 224) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
          } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(
              ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            i += 3;
          }
        }
        return string;
      };
    },
    download(data) {
      this.inputObj = data;
    },
    initDim() {
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.projects = this.dictCache("projects");
      }
      if (!window.sessionStorage.getItem("fileTypes")) {
        this.postRequest("/dim/dim_table_char/file_type").then((resp) => {
          if (resp) {
            this.fileTypes = resp.result;
            this.saveDictCache("fileTypes", resp.result);
          }
        });
      } else {
        this.fileTypes = this.dictCache("fileTypes");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initData();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initData();
    },
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.initData();
    },

    initData() {
      //   TbProjectFileController.java
      this.loading = true;
      this.getRequest(
        "/file/list?page=" +
          this.page +
          "&limit=" +
          this.limit +
          "&fileType=" +
          this.fileType +
          "&projectName=" +
          this.projectName
      ).then((resp) => {
        this.loading = false;
        if (resp) {
          this.incomeData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style></style>
